import { render, staticRenderFns } from "./TwitterButton.vue?vue&type=template&id=38b3adfb&scoped=true"
import script from "./TwitterButton.vue?vue&type=script&lang=js"
export * from "./TwitterButton.vue?vue&type=script&lang=js"
import style0 from "./TwitterButton.vue?vue&type=style&index=0&id=38b3adfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3adfb",
  null
  
)

export default component.exports